import React from "react";
import { useBrand, useTranslation } from "@edreamsodigeo/frontend-core";
import { Body } from "@edreamsodigeo/prisma-design-system";
import CardWithBackgroundImage from "../common/components/CardWithBackgroundImageBanner";
import ValuePropositionHeader from "./components/ValuePropositionHeader";
import { getBrandedImage } from "../../utils/images";
const SupportAreaValuePropositionMobile = () => {
  const {
    t
  } = useTranslation();
  const brand = useBrand();
  return /*#__PURE__*/React.createElement(CardWithBackgroundImage, {
    title: /*#__PURE__*/React.createElement(ValuePropositionHeader, null),
    description: /*#__PURE__*/React.createElement(Body, {
      type: "xSmall",
      color: "neutral.90"
    }, t("supportarea.mytripslogin.banner.text")),
    backgroundColor: "primary.20",
    backgroundSize: "120px",
    backgroundPosition: "calc(100% + 30px) calc(100%)",
    backgroundImage: getBrandedImage("BSA_images_SA.png", brand, "/images/SEP/SA/"),
    boxPaddingBottomMobile: "2x_big"
  });
};
export default SupportAreaValuePropositionMobile;